import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import TenantSharingReducer from "../reducers/TenantSharingReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { TenantSharingConstants } from "../constants/tenant_sharing.constants";
import { saveFile } from "../utils/common";
const initialState = {
  tenantSharings: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  tenantSearchResults: [],
  tenant: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isSubmitting: false,
  isLoading: true,
  tenantSharingAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },

  isAutoSearchLoading: true,
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const TenantSharingContext = createContext({
  ...initialState,
  getAllTenantSharing: () => {},
  addTenantSharing: () => {},
  searchTenantSharing: () => {},
  autoSearchTenantSharing: () => {},
  getTenantSharing: () => {},
  updateTenantSharing: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
});

function TenantSharingProvider({ children }) {
  const [state, dispatch] = useReducer(TenantSharingReducer, initialState);

  const getAllTenantSharing = async (payload) => {
    try {
      const response = await axios.post("/hyper/tenant/sharing/list", payload);
      dispatch({
        type: TenantSharingConstants.FETCH_TENANT_SHARING_REQUEST,
      });
      dispatch({
        type: TenantSharingConstants.FETCH_TENANT_SHARING_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: TenantSharingConstants.FETCH_TENANT_SHARING_FAILURE,
      });
    }
  };
  const searchTenantSharing = async () => {
    try {
      const response = await axios.post("/hyper/tenant/search", initPayload);
      dispatch({
        type: TenantSharingConstants.TENANT_SHARING_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: TenantSharingConstants.TENANT_SHARING_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: TenantSharingConstants.TENANT_SHARING_SEARCH_FAILURE,
      });
    }
  };
  const addTenantSharing = async (payload) => {
    const response = await axios.post("/hyper/tenant/sharing/add", payload);
    dispatch({
      type: TenantSharingConstants.ADD_TENANT_SHARING_REQUEST,
    });
    dispatch({
      type: TenantSharingConstants.ADD_TENANT_SHARING_SUCCESS,
      payload: response.data,
    });
  };

  const autoSearchTenantSharing = async (payload) => {
    try {
      const response = await axios.post("/hyper/tenant/auto-search", payload);
      dispatch({
        type: TenantSharingConstants.TENANT_SHARING_AUTO_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: TenantSharingConstants.TENANT_SHARING_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: TenantSharingConstants.TENANT_SHARING_AUTO_SEARCH_FAILURE,
        payload: exception,
      });
    }
  };

  const getTenantSharing = async (id) => {
    const response = await axios.get("/hyper/tenant/" + id);
    dispatch({
      type: TenantSharingConstants.GET_TENANT_SHARING_REQUEST,
    });
    dispatch({
      type: TenantSharingConstants.GET_TENANT_SHARING_SUCCESS,
      payload: response.data,
    });
  };

  const updateTenantSharing = async (payload) => {
    const response = await axios.put("/hyper/tenant/update/" + payload.tenantId, payload);
    dispatch({
      type: TenantSharingConstants.UPDATE_TENANT_SHARING_REQUEST,
    });
    dispatch({
      type: TenantSharingConstants.UPDATE_TENANT_SHARING_SUCCESS,
      payload: response.data,
    });
  };

  const downloadFile = async (fileType, payload) => {
    const response = await axios.post("/hyper/tenant/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "tenant." + fileType);
    dispatch({
      type: TenantSharingConstants.DOWNLOAD_TENANT_SHARING_REQUEST,
    });
    dispatch({
      type: TenantSharingConstants.DOWNLOAD_TENANT_SHARING_SUCCESS,
      payload: response.data,
    });
  };

  const sampleFile = async (fileType) => {
    const response = await axios.get("/hyper/tenant/sample/" + fileType, {
      responseType: "blob",
    });

    await saveFile(response.data, "sample_tenant." + fileType);
    dispatch({
      type: TenantSharingConstants.DOWNLOAD_TENANT_SHARING_REQUEST,
    });
    dispatch({
      type: TenantSharingConstants.DOWNLOAD_TENANT_SHARING_SUCCESS,
      payload: response.data,
    });
  };

  const uploadFile = async (payload) => {
    try {
      dispatch({
        type: TenantSharingConstants.UPLOAD_TENANT_SHARING_REQUEST,
      });
      const response = await axios({
        url: "/hyper/tenant/upload",
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: TenantSharingConstants.UPLOAD_TENANT_SHARING_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log("errr", error);
      dispatch({
        type: TenantSharingConstants.UPLOAD_TENANT_SHARING_FAILURE,
      });
    }
  };

  return (
    <TenantSharingContext.Provider
      value={{
        ...state,
        getAllTenantSharing,
        addTenantSharing,
        searchTenantSharing,
        getTenantSharing,
        updateTenantSharing,
        downloadFile,
        sampleFile,
        uploadFile,
        autoSearchTenantSharing,
      }}
    >
      {children}
    </TenantSharingContext.Provider>
  );
}

export { TenantSharingContext, TenantSharingProvider };
